import { useState } from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import { TApi } from '../../../../shared/const'
import http from '../../../../shared/http'
import { useAvatarUrl } from '../../../../shared/useAvatarUrls'

import AvatarUploader from '../../../../UI/AvatarUploader'

import styles from './avatarField.module.scss'

/**
 * Profilbild im Self-Service.
 *
 * Seit 23.08.2026 nur noch die Anbindung an die Schnittstelle — Auswahl,
 * Prüfung und Zuschneiden liegen in `UI/AvatarUploader`, damit alle vier Rollen
 * dasselbe Fenster bekommen.
 */
export default function AvatarField({ displayName, avatarHashName, onChange }) {
	const { t } = useTranslation()
	const [isBusy, setBusy] = useState(false)
	const src = useAvatarUrl(avatarHashName)

	const hochladen = file => {
		const form = new FormData()
		form.append('avatar', file)

		setBusy(true)
		http.put(TApi.SUPPORTER_AVATAR, form, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
			.then(({ data }) => {
				toast.success(t('Saved successfully'))
				onChange(data.avatarHashName)
			})
			.finally(() => setBusy(false))
	}

	const entfernen = () => {
		setBusy(true)
		http.delete(TApi.SUPPORTER_AVATAR)
			.then(() => {
				toast.success(t('Saved successfully'))
				onChange(null)
			})
			.finally(() => setBusy(false))
	}

	return (
		<div className={styles.root}>
			<AvatarUploader
				src={src}
				name={displayName}
				size={96}
				disabled={isBusy}
				onSelect={hochladen}
				onClean={entfernen}
			/>
		</div>
	)
}
